import React from 'react'
import { object } from 'prop-types'
import { withContext } from '../../../utils/withContext'
import { validateEmail } from '../..//helpers/validations'
import { postRequest } from '../..//helpers/requestActions'
import styles from './ContactForm.styl'

class ContactForm extends React.Component {

	static propTypes = {
		context: object
	}

	state = {
		message: { email: '', name: '', subject: '', message: '' },
		error: { email: false, name: false, subject: false, message: false },
		success: false,
		processing: false
	}

	handleError(message) {
		const error = {}
		const { email, ...inputs } = message
		Object.entries(inputs).forEach(([key, value]) => {
			error[key] = !value
		})
		error['email'] = !validateEmail(email)
		return error
	}

	handleSubmit() {
		const { message } = this.state
		const error = this.handleError(message)
		if (Object.values(error).some(arg => arg)) {
			this.setState({ error, processing: false })
			return
		}
		postRequest('/api/contacts/info', message)
			.then(() => {
				this.setState({ error, success: true, processing: false })
			})
			.catch(() => {
				console.log('error')
				this.setState({ error, processing: false })

			})
	}

	render() {
		const { message, error, success, processing } = this.state
		const { context: { i18n } } = this.props
		return (
			<div className={ styles['form-container'] }>
				<form
					onSubmit={ (e) => {
						e.preventDefault()
						this.setState({ processing: true }, () => {
							if (!processing && !success) {
								this.handleSubmit()
							}
						})
					}
					}
				>
					<div className={ styles['double-input-row'] }>
						<div className={ styles['input-container'] }>
							<input className={ `${ error.name ? styles.error : null }` } type="text" placeholder={ i18n`name_label` } value={ message.name } onChange={ (e) => this.setState({ message: { ...message, name: e.target.value } }) } />
						</div>
						<div className={ styles['input-container'] }>
							<input className={ `${ error.email ? styles.error : null }` } type="text" placeholder={ i18n`email_label` } value={ message.email } onChange={ (e) => this.setState({ message: { ...message, email: e.target.value } }) } />
						</div>
					</div>
					<div className={ `${ styles['single-input-row'] } ${ styles['input-container'] }` }>
						<input className={ `${ error.subject ? styles.error : null }` } type="text" placeholder={ i18n`subject_label` } value={ message.subject } onChange={ (e) => this.setState({ message: { ...message, subject: e.target.value } }) } />
					</div>
					<div className={ styles.textareaDiv }>
						<textarea className={ `${ error.message ? styles.error : null }` } placeholder={ i18n`message_label` } value={ message.message } onChange={ (e) => this.setState({ message: { ...message, message: e.target.value } }) } />
					</div>
					<button className={ `${ styles.submit } ${ success ? styles['sent'] : '' }` } >{ success ? i18n`sent_message_label` : i18n`send_your_message_label` }</button>
				</form >
			</div >
		)
	}
}

export default withContext(ContactForm)



// WEBPACK FOOTER //
// ./src/client/website/components/ContactForm/ContactForm.js